export const internalComponentRegistry = {};
